/**
 * Convert string to PascalCase
 */
export const toPascalCase = (str: string): string => {
  return str
    .toLowerCase()
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join('')
}

/**
 * Get item type based on treatment and menu type
 */
export const getItemType = (
  treatment: any,
  menu: 'PAYMENT' | 'OVERDUE' | 'RETROSPECTIVE' | 'EDIT_PAYMENT',
  index?: number
): { type: string; id: any } => {
  let type = ''
  let id: any = null


  if (treatment.tempOrderTreatmentId || treatment.orderTreatmentId) {
    id = treatment.tempOrderTreatmentId || treatment.orderTreatmentId
  } else if (treatment.tempOrderProductId || treatment.orderProductId) {
    id = treatment.tempOrderProductId || treatment.orderProductId
  } else {
    id = parseInt(String(index)) + 1
  }

  const isTreatment = !!(treatment.tempOrderTreatmentId || treatment.orderTreatmentId || treatment.operativeId)

  if (menu === 'RETROSPECTIVE') {
    if (treatment.type && (treatment.type !== 'OPERATIVE' && treatment.type !== 'TREATMENT')) {
      type = 'ORDER_PRODUCT'
    } else {
      type = isTreatment ? 'ORDER_TREATMENT' : 'ORDER_PRODUCT'
    }
  } else if (menu === 'OVERDUE') {
    type = isTreatment ? 'ORDER_TREATMENT' : 'ORDER_PRODUCT'
  } else if (menu === 'EDIT_PAYMENT') {
    type = isTreatment ? 'ORDER_TREATMENT' : 'ORDER_PRODUCT'
  } else {
    type = isTreatment ? 'TEMP_ORDER_TREATMENT' : 'TEMP_ORDER_PRODUCT'
  }

  return { type, id }
}
